import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { Users, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DirectoryPage() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { if (!authLoading && !user) navigate("/login"); }, [user, authLoading, navigate]);

  useEffect(() => {
    if (user) {
      axios.get(`${API}/members`).then(res => setMembers(res.data)).catch(() => {}).finally(() => setLoading(false));
    }
  }, [user]);

  if (authLoading || !user) return null;

  return (
    <div data-testid="directory-page">
      <section className="bg-[#1C2E4A] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#C8A97E] font-semibold mb-3">Community</p>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-white">Member Directory</h1>
        </div>
      </section>
      <section className="py-12 md:py-16 bg-white min-h-[50vh]">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          {loading ? (
            <div className="text-center py-20"><Loader2 className="w-6 h-6 text-[#C8A97E] animate-spin mx-auto" /></div>
          ) : members.length === 0 ? (
            <div className="text-center py-20">
              <Users className="w-12 h-12 text-[#E5E2DC] mx-auto mb-4" />
              <p className="text-[#595959]">No members yet. Be the first!</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {members.map((m, i) => (
                <div key={i} data-testid={`member-${i}`} className="bg-[#FAF9F6] rounded-xl border border-[#E5E2DC] p-5 flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-[#1C2E4A]/10 flex items-center justify-center shrink-0">
                    <span className="text-sm font-semibold text-[#1C2E4A]">{(m.name || "?")[0].toUpperCase()}</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-[#1C2E4A]">{m.name}</p>
                    <p className="text-xs text-[#595959]">Member since {new Date(m.created_at).toLocaleDateString()}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
